/// <reference path="../ObjectDataBuilder.ts" />

namespace SPA
{
	export namespace Realtor
	{

		export class EnergyCertificateBuilder
			extends ObjectDataBuilder<Wollmilch.Realtor.Object>
		{

			private	m_Parent:	JQuery|ui.base.BaseHTMLElement|null;

			public constructor( data: Wollmilch.Realtor.Object )
			{
				super( data );

				this.m_Parent	= null;
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery, navigation?: Navigation ): EnergyCertificateBuilder
			{
				this.m_Parent	= root;
				const basicBox	= new ui.Box.Box();

				basicBox.clearTitle();
				basicBox.addTitle( 'Energieausweis' );
				basicBox.rebuild( root.empty() );

				const addbtn = new ui.base.BaseHTMLElement<HTMLButtonElement>( 'button' );
				const btntxt = ui.$$.span().appendTo( addbtn.Root() ).addClass( 'fas fa-plus' );

				addbtn.addClass( 'btn btn-sm btn-default' )
				.css( { 'margin-left': '1em' } )
				.on(
					{
						click: () => this.buildECForm()
					}
				);

				basicBox.append(
					ui.$$.p()
						.append( app.getSpanMessage( 'Aux.BASIC.OBJECT.REALTOR.LONG.new_additional_energycertificate' ) )
						.append( addbtn.Root() )
				);

				new Wollmilch.AJAX(
					{
						url: 'EnergyCertificate/list/' + encodeURIComponent( btoa( this.m_Data.ObjectNumber ) ),
						method: 'GET',
						data: { object: this.m_Data.ObjectNumber },
						on:
						{
							success: ( text: string ) =>
							{
								const obj = Wollmilch.jsonize( text );

								if ( !obj || !obj.success || !obj.data )
								{
									app.addNotify(
										{
											title: [ 'Energieausweis' ],
											body: [ 'Fehler beim Laden der Energieausweise' ],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									return;
								}

								// TODO Hier die UI erstellen!!!!
								app.addNotify(
									{
											title: [ 'Energieausweis' ],
											body: [ obj.count + " Energieausweis(-e) geladen" ],
											context: obj.count > 0 ? 'success' : 'warning',
											timeout: Number(app.getConfigValue("ToastTimeout"))
									}
								);

								const list = new ui.base.BaseHTMLElement( 'card-list' ).appendTo( basicBox );

								(obj.data as Wollmilch.Realtor.EnergyCertificateObject[]).forEach(
									(element) =>
									{
										const row = ui.$$.div().addClass( 'row' );

										let endenergiebedarf: JQuery;
										const oe = element.Data[ 'overall-efficiency' ];
										if ( oe !== null )
										{
											endenergiebedarf = ui.$$.span().text( 'Endenergieverbrauch: ' + oe + 'kWh/(m²*a)' ).css( 'font-weight', 'bold' );
										}
										else
										{
											endenergiebedarf = ui.$$.span().text( 'Endenergieverbrauch: Keine Angabe' ).css( 'font-weight', 'bold' );
										}

										let primaerenergiebedarf: JQuery;
										const pc = element.Data[ 'primary-consumption' ];
										if ( pc )
										{
											primaerenergiebedarf = ui.$$.span().text( 'Primärenergieverbrauch: ' + pc + 'kWh/(m²*a)' ).css( 'font-weight', 'bold' );
										}
										else
										{
											primaerenergiebedarf = ui.$$.span().text( 'Primärenergieverbrauch: Keine Angabe' ).css( 'font-weight', 'bold' );
										}

										const col = ui.$$.div().addClass( 'col-xs-12' ).appendTo( row );

										col.append( primaerenergiebedarf );

										new SPA.Realtor.EnergyCertificateVisual( oe, pc, element.Data.type === 'needs' ? 450 : 250, element.Data.type === 'needs' ? 50 : 25, element.Data.type ).rebuild( col );

										col.append( endenergiebedarf );

										const card = new ui.base.BaseHTMLElement( 'card' ).addClass( 'box' )
										.append(
											ui.$$.p().addClass( 'box-title small-caps' )
												.text( 'Stichtag: ' + new Date( element.KeyDate ).pattern( 'd.m.Y' ) + ' - ' + app.getMessage( 'Aux.BASIC.TRANSLATION.energycertificate_' + element.Data.type ) )
											).appendTo( list );

										let buttonplane: JQuery;
										const wrench	= ui.$$.button().css(
											{
												'background-color':	'#555',
												"color":							'#ddd',
												"border":							'0 none',
												"width":							'36px',
												"height":							'36px',
												"margin":							'2px',
												'border-radius':		'50%'
											}
										)
										.attr( 'title', 'Aktionen' )
										.append( ui.$$.span().addClass( 'fas fa-wrench' ) );
										const actions	= ui.$$.div()
										.css(
											{
												position:					'absolute',
												top:							'10px',
												right:						'10px'
											}
										)
										.append( wrench )
										.on(
											{
												click: () =>
												{
													buttonplane.removeClass( 'hidden' );
													wrench.addClass( 'hidden' );
												},
												mouseleave: () =>
												{
													buttonplane.addClass( 'hidden' );
													wrench.removeClass( 'hidden' );
												}
											}
										)
										.appendTo( card.Root() );

										buttonplane = ui.$$.div()
										.css(
											{
												// position:						'relative',
												"display":						'flex',
												// float:							'right',

												'flex-flow':				'row wrap',
												'justify-content':	'flex-end',

												// top:								'0px',
												// right:							'0px',
												"width":							'220px',

												'background-color': 'transparent'
											}
										)
										.addClass( 'hidden' )
										.appendTo( actions );

										card.append( row );

										ui.$$.button().
										on( 'click', () => this.buildECForm( new Wollmilch.Realtor.EnergyCertificate( element ) ) )
										.append( ui.$$.span().addClass( 'fas fa-pen' ) )
										.addClass( 'btn btn-primary' )
										.appendTo( buttonplane )
										.attr( 'title', 'Energieausweis bearbeiten' )
										.css(
											{
												width:	'39px',
												height:	'34px',
												margin:	'3px'
											}
										);

										new ui.base.Button(
											ui.$$.span().addClass( 'fas fa-upload' ),
											{
												css:
												{
													width:	'39px',
													height:	'34px',
													margin:	'3px'
												},
												attr:
												{
													title: 'Energieausweis hochladen'
												},
												context: 'warning',
												on:
												{
													click: () => this.buildUploadForm( new Wollmilch.Realtor.EnergyCertificate( element ) )
												}
											}
										)
										.rebuild( buttonplane );

										if ( element.Artifact.MimeType && element.Artifact.DataLength )
										{
											ui.$$.button()
											.on(
												'click',
												() => this.loadBlob(
													element, ( data: any ) =>
													{
														const srcStr = 'data:' + data.MimeType + ';' + ( data.Base64 ? 'base64,' : '' );

														let modal: ui.dialog.Modal;

														modal = new ui.dialog.Modal(
															{
																size:				'lg',
																body:				[ ui.$$.img().attr( 'src', srcStr + data.Blob ) ],
																noCloseBtn:	true,
																css:
																{
																	cursor: 'zoom-out'
																}
															}
														);
														modal.on( 'click', () => modal.Hide() );
													}
												)
											)
											.append( ui.$$.span().addClass( 'fas fa-tv' ) )
											.addClass( 'btn btn-info' )
											.appendTo( buttonplane )
											.attr( 'title', 'Energieausweis anzeigen' )
											.css(
												{
													width:	'39px',
													height:	'34px',
													margin:	'3px'
												}
											);

											ui.$$.button()
											.on( 'click', () => this.loadBlob( element, ( data: Wollmilch.ArtifactDownload ) => this.downloadFile( data ) ) )
											.append( ui.$$.span().addClass( 'fas fa-download' ) )
											.addClass( 'btn btn-default' )
											.appendTo( buttonplane )
											.attr( 'title', 'Energieausweis herunterladen' )
											.css(
												{
													width:	'39px',
													height:	'34px',
													margin:	'3px'
												}
											);
										}
									}
								);
							}
						}
					},
					Wollmilch.AJAXCallbase_e.REALTOR
				).send();

				return this;
			}

			private buildUploadForm( ec: Wollmilch.Realtor.EnergyCertificate ): void
			{
				const FileUpload = ui.$$.div();

				// @ts-ignore
				const galleryUploader = new qq.FineUploader(
					{
						element: FileUpload[ 0 ],
						template: 'qq-template-gallery',
						multiple: false,
						validation:
						{
							allowedExtensions: [ 'pdf' ]
						},
						autoUpload: false,
						emptyError: 'Aux.ERROR.file_empty',
						noFilesError: 'Aux.ERROR.no_files',
						request:
						{
							customHeaders:
							{
								'GSDWollmilch-API-Key': 'API-KEY',
								'GSDWollmilch-API-AuthToken': app.getAuthenticationManager().getAuthToken()
							},
							forceMultipart: true,
							method: 'PUT',
							paramsInBody: true,
							endpoint: ( Wollmilch.useHTTPS ? "https" : "http" ) + "://" + Wollmilch.URL + 'api/v1/artifact/blob/' + ec.Artifact().ID()
						},
						cors:
						{
							// all requests are expected to be cross-domain requests
							expected: true,

							// if you want cookies to be sent along with the request
							sendCredentials: true
						}
					}
				);

				const modal: ui.dialog.Modal = new ui.dialog.Modal(
					{
						size: 'lg',
						head:	[ ui.$$.h( 4, app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.SHORT.set_energycertificate_file' ) ) ],
						body: [ FileUpload ],
						foot:	[
							ui.$$.button().text( app.getMessage( 'Aux.SAVE_BTN' ) ).addClass( 'btn btn-success' ).on(
								'click', () =>
								{
									try
									{
										galleryUploader.uploadStoredFiles();
									}
									catch ( nofileserror )
									{
										app.addNotify(
											{
												title: [ 'FILE_UPLOAD' ],
												body: [ 'ERROR.NO_FILES_SELECTED_TO_UPLOAD' ],
												context: 'warning',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}

									modal.Hide();

									if ( this.m_Parent ) { this.rebuild( this.m_Parent ); }
								}
							),
							ui.$$.button().text( app.getMessage( 'Aux.ABORT_BTN' ) ).addClass( 'btn btn-danger' ).on(
								'click', () => modal.Hide()
							)
						]
					}
				);
			}

			private buildECForm( ec?: Wollmilch.Realtor.EnergyCertificate ): void
			{
				let modal: ui.dialog.Modal;

				const formCallback = ec ?
					( action: string, method: string, params: Wollmilch.Realtor.EnergyCertificateObject ) =>
					{
						ec.edit(
							params.Data,
							( response: Wollmilch.ResponseObject, ec: Wollmilch.Realtor.EnergyCertificate ) =>
							{
								if ( !response.success )
								{
									app.addNotify(
										{
											title: [ ui.$$.h( 4, app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.SHORT.new_additional_energycertificate' ) ) ],
											body: [ 'Energieausweis konnte nicht bearbeitet werden.' ],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									return;
								}

								if ( this.m_Parent ) { this.rebuild( this.m_Parent ); }

								modal.Hide();
							}
						);
					} :
					( action: string, method: string, params: Wollmilch.Realtor.EnergyCertificateObject ) =>
					{
							Wollmilch.Realtor.EnergyCertificate.create(
								params.ObjectNumber,
								params.KeyDate,
								params.Data,
								( response: Wollmilch.ResponseObject, ec?: Wollmilch.Realtor.EnergyCertificate ) =>
								{
									if ( !ec )
									{
										app.addNotify(
											{
												title: [ ui.$$.h( 4, app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.SHORT.new_additional_energycertificate' ) ) ],
												body: [ 'Energieausweis konnte nicht erstellt werden.' ],
												context: 'danger',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}

									if ( this.m_Parent ) { this.rebuild( this.m_Parent ); }

									modal.Hide();
								}
							);
						};

				const form = new ui.Form.Form(
							// @ts-ignore
							{
								action: '',
								method: 'POST',
								notSwitchable: true,
								static: false,
								//@ts-ignore
								submit: formCallback
							}
						);

				const form_parent = ui.$$.div();

				form.Initialize();

				form.rebuild( form_parent );

				modal = new ui.dialog.Modal(
					{
						size: 'lg',
						head:	[ ui.$$.h( 4, app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.SHORT.' + ( ec ? 'edit_energycertificate' : 'new_additional_energycertificate' ) ) ) ],
						body: [ form_parent ],
						foot: [
							$( form.Buttons.submit.getElement() ).text( app.getMessage( ec ? 'Aux.EDIT_BTN' : 'Aux.SAVE_BTN' ) ),
							$( form.Buttons.cancel.getElement() ).on( 'click', () => modal.Hide() ).text( app.getMessage( 'Aux.ABORT_BTN' ) )
						]
					}
				);

				const addInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };

				form.append(
					ui.$$.div().addClass( 'form-group formless' ).append(
						ui.$$.p().addClass( 'form-required text-danger small-caps' ).text( app.getMessage( 'Aux.REQUIRED_INPUTS' ) )
					)
				);

				addInput( new ui.Form.HiddenTextInput( this.m_Data.ObjectNumber, 'ObjectNumber' ), [] );

				const keydate = new ui.Form.DateInput(
						ec ?
							ec.KeyDate() :
							new Date(),
						'd.m.Y',
						{
							name: 'KeyDate',
							required: true,
							control: true,
							readonly: ec ? true : false
						}
					).rebuild(
							ui.$$.div().addClass( 'row' ).appendTo( form.Root() )
							.append( ui.$$.label().addClass( 'col-xs-12 col-sm-4' ).text( 'Stichtag' + '*' ) )
				);
				if ( !ec )
				{
					addInput( keydate, [ 'col-xs-12', 'col-sm-8' ] );
				}
				else
				{
					keydate.Base().addClass( [ 'col-xs-12', 'col-sm-8' ].join( ' ' ) );
				}

				addInput(
					new ui.Form.RadioGroup(
						{
							value: ec ? ec.Type() : null,
							inline: 2,
							required: true,
							name: 'Data.type',
							radioButtons:
							[
								{
									value: 'consumptions',
									title: 'Verbrauchsausweis',
								},
								{
									value: 'needs',
									title: 'Bedarfsausweis'
								}
							]
						}
					).rebuild(
							ui.$$.div().addClass( 'row' ).appendTo( form.Root() )
							.append( ui.$$.label().addClass( 'col-xs-12 col-sm-4' ).text( 'Art des Ausweis\'' + '*' ) )
					),
					[ 'col-xs-12', 'col-sm-8' ]
				);

				addInput(
					new ui.Form.LabelledNumberSlider(
						ec ? ec.OverallEfficiency() || -1 : -1,
						{
							min: 0,
							max: 800,
							step: 1,
							sentinal: 'Keine Angabe',
							name: 'Data.overall-efficiency',
							control: true
						},
						( n: number ) => n + ' kWh/(m²*a)'
					).rebuild(
							ui.$$.div().addClass( 'row' ).appendTo( form.Root() )
							.append( ui.$$.label().addClass( 'col-xs-12 col-sm-4' ).text( 'Endenergiebedarf' + '*' ) )
					),
					[ 'col-xs-12 col-sm-8' ]
				);

				addInput(
					new ui.Form.LabelledNumberSlider(
						ec ? ec.PrimaryConsumption() || -1 : -1,
						{
							min: 0,
							max: 800,
							step: 1,
							sentinal: 'Keine Angabe',
							name: 'Data.primary-consumption',
							control: true
						},
						( n: number ) => n + ' kWh/(m²*a)'
					).rebuild(
							ui.$$.div().addClass( 'row' ).appendTo( form.Root() )
							.append( ui.$$.label().addClass( 'col-xs-12 col-sm-4' ).text( 'Primärenergiebedarf' + '*' ) )
					),
					[ 'col-xs-12 col-sm-8' ]
				);
			}

			private downloadFile( data: Wollmilch.ArtifactDownload )
			{
				const srcStr = 'data:' + data.MimeType + ';' + ( data.Base64 ? 'base64,' : '' );
				const element = document.createElement('a');
				element.setAttribute( 'href', srcStr + data.Blob );
				/* TODO sobald in der DB der Dateiname des Artefaktes mitgespeichert wird, diesen verwenden */
				element.setAttribute( 'download', 'downloadfile.bin' /* TODO data.Filename*/ );

				element.style.display = 'none';
				document.body.appendChild(element);

				element.click();

				document.body.removeChild(element);
			}

			private loadBlob(
				att: Wollmilch.Realtor.EnergyCertificateObject,
				onsuccess: ( data: Wollmilch.ArtifactDownload ) => void
			)
			{
				new Wollmilch.AJAX(
					{
						url: 'artifact/download/' + att.Artifact.ID,
						method: 'GET',
						on:
						{
							success: ( text: string ) =>
							{
								const obj = Wollmilch.jsonize( text );

								if ( !obj || obj.success === false )
								{
									return;
								}

								onsuccess( obj.data );
							}
						}
					}
				).send();
			}

		}

	}
}
